import React from 'react'
import { VideoHelper } from './imports'
import { videoStates } from './spotStateConstants'
const dogSleeping = require('../../../assets/studentPreChecks/spot_sleeping.gif')
const dogAwake = require('../../../assets/studentPreChecks/spot_playful.gif')

export default function Spot(props){

    const { spotState } = props

    const isInvisible = spotState === videoStates.invisible
    const isSleeping = spotState === videoStates.sleeping
    const isAwake = spotState === videoStates.awake || spotState === videoStates.wokeUpFromSleep

    if( isInvisible ){
        return null
    }

    if( isSleeping ){
        return <VideoHelper videoSrc={dogSleeping} loop={true}/>
    }
    
    if( isAwake ){
        return <VideoHelper videoSrc={dogAwake} loop={true}/>
    }

    // default to sleep
    return <VideoHelper videoSrc={dogSleeping} loop={true}/>
}